import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { Subject } from "rxjs";


import { HubConnection } from "./hub-connection";

@Injectable()
export class HubProxy<T> {
    //Subject to Notify about incoming changes
    private _events: Subject<T> = new Subject<T>();
    private hubProxy: any;
    private noOfNotifications: number = 0;

    constructor(public hubConnection: HubConnection, hubName: string, eventHandlerName: string, private traceModule: string) {
        this.hubProxy = hubConnection.getHubProxy(hubName);
        this.hubProxy.on(eventHandlerName, (eventArgs: T) => {
            if (this._events !== undefined) {
                this.noOfNotifications++;
                return this._events.next(eventArgs);
            }
        });
    }

    public get connectionId(): string {
        return this.hubProxy.connection.id;
    }

    public get events(): Observable<T> {
        return this._events.asObservable();
    }
}
